export enum stopConstants {
  GET_STOPS = 'GET_STOPS',
  GET_STOP = 'GET_STOP',
  ADD_STOP = 'ADD_STOP',
  EDIT_STOP = 'EDIT_STOP',
  DELETE_STOP = 'DELETE_STOP',
}
